import { gl, Context } from './context.js'
import { Assets } from './assets/assets'
import { Renderer } from './renderer'

Context();

var modelsPromises = Assets();

modelsPromises
  .then(models => Renderer(models))
  .catch(error => console.error(error));
